import { Button, Col, Form, Typography, useTheme, useToast } from "@commonlibs";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "ui/locale";
import ExternalLink from "ui/router/components/ExternalLink/ExternalLink";
import { useAcceptTermsAndConditions } from "features/organization-terms/hooks/useAcceptTermsAndConditions";
import { useGetOrganizationInfo } from "features/organization/hooks/useGetOrganizationInfo";
import { config } from "common/config";
import { Queries } from "ui/query/queries";
import React from "react";

function AcceptTermsAndConditionsForm(): JSX.Element {
    const { spacing } = useTheme();
    const navigate = useNavigate();
    const { showToast } = useToast();
    const translate = useTranslate();
    const queryClient = useQueryClient();
    const organizationAddress = config.organization.address;

    const { data: organization } = useGetOrganizationInfo();

    const { mutate: acceptTermsAndConditions, isLoading: acceptTermsAndConditionsLoading } = useAcceptTermsAndConditions({
        onSuccess: handleUpdateUserSuccess,
    });

    function handleUpdateUserSuccess() {
        showToast(translate("personalDataUpdatedMessage"), { type: "success" });
        queryClient.invalidateQueries([Queries.USER_INFO, organizationAddress]);
        navigate("/", { replace: true });
    }

    const handleSubmit = () => {
        acceptTermsAndConditions();
    };

    return (
        <Form onSubmit={handleSubmit} style={{ height: "100%" }}>
            <Col gap={spacing[6]} flex="1" justifyContent="flex-end" style={{ height: "100%" }}>
                <Col flex={1} gap={spacing[22]}>
                    <Typography variant="h3Strong">{translate("termsAndConditionsHaveBeenUpdated")}</Typography>
                    <Typography variant="body2Regular">
                        {translate("termsAndConditionsHaveBeenUpdatedMessage", { organization: organization?.name })}
                    </Typography>
                    <Col gap={spacing[4]}>
                        <ExternalLink href={organization?.organizationTerms?.termsAndConditionsUrl || ""}>
                            <Typography variant="body2Regular" css={{textDecoration:"underline"}} >{translate("seeTermsAndConditions")}</Typography>
                        </ExternalLink>
                        <ExternalLink href={organization?.organizationTerms?.personalDataTreatmentUrl || ""}>
                            <Typography variant="body2Regular" css={{textDecoration:"underline"}}>{translate("seePersonalDataTreatment")}</Typography>
                        </ExternalLink>
                        <ExternalLink href={organization?.organizationTerms?.privacyPolicyUrl || ""}>
                            <Typography variant="body2Regular" css={{textDecoration:"underline"}}>{translate("seePrivacyPolicy")}</Typography>
                        </ExternalLink>
                    </Col>
                </Col>
                <Button variant="primary" fullWidth loading={acceptTermsAndConditionsLoading} type="submit">
                    {translate("acceptAndContinue")}
                </Button>
            </Col>
        </Form>
    );
}

export default AcceptTermsAndConditionsForm;
